export default {
  data() {
    return {
      actions: [
        {
          name: 'Cuona.Event.event01',
          type: 'checkin',
          image: require('@/assets/event_checkin.svg'),
          plugin: false
        },
        {
          name: 'Cuona.Event.event03',
          type: 'checkout',
          image: require('@/assets/event_checkout.svg'),
          plugin: false
        },
        {
          name: 'Cuona.Event.event04',
          type: 'public_url',
          image: require('@/assets/event_shareurl.svg'),
          plugin: false
        },
        {
          name: 'Cuona.Event.event05',
          type: 'custom_url',
          image: require('@/assets/event_customurl.svg'),
          plugin: false
        },
        {
          name: 'Cuona.Event.event06',
          type: 'favor',
          image: require('@/assets/favor_logo.svg'),
          plugin: true
        },
        {
          name: 'Cuona.Event.record',
          type: 'record',
          image: require('@/assets/record_logo.svg'),
          plugin: true
        },
        {
          name: 'Cuona.Event.remotelock',
          type: 'remotelock',
          image: require('@/assets/remotelock_logo.svg'),
          plugin: true
        },
        {
          name: 'Cuona.Event.clue',
          type: 'clue',
          image: require('@/assets/clue_logo.svg'),
          plugin: true
        },
      ]
    }
  },
  methods: {
    showActionName(type) {
      const action = this.actions.find(action => action.type === type);
      return action.name;
    },
    showActionIcon(type) {
      const action = this.actions.find(action => action.type === type);
      return action.image;
    },
    getAvailableActions(plugins) {
      const availableActions = this.actions.filter(action => !action.plugin);
      plugins.forEach(plugin => {
        const action = this.actions.find(action => plugin.enabled && action.plugin && action.type === plugin.plugin_type);
        if(action) availableActions.push(action);
      })
      return availableActions;
    }
  }
}
